import {Alert, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {useEffect} from "react";
import {useDispatch} from "react-redux";

import {Text} from "@bounce/shared/ui";
import {Notification} from "../store/definitions";
import {removeNotification} from "../store/actions/genericActions";

const getAlertSeverity = (type: Notification["type"]) => {
  switch (type) {
    case "error":
      return "error";
    case "warning":
      return "warning";
    case "neutral":
      return "info";
    default:
      return "info";
  }
};

export const NotificationBarItem = ({dismissible, id, message, onDismiss, timeout, type}: Notification) => {
  const dispatch = useDispatch();

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (timeout) {
      timer = setTimeout(() => {
        dispatch(removeNotification(id));
        if (onDismiss) {
          onDismiss();
        }
      }, timeout);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, timeout, id, onDismiss]);

  const dismissNotification = () => {
    if (onDismiss) {
      onDismiss();
    }
    dispatch(removeNotification(id));
  };

  return (
    <Alert
      role="status"
      aria-live="polite"
      severity={getAlertSeverity(type)}
      action={
        dismissible ? (
          <IconButton aria-label="close" color="inherit" size="small" onClick={dismissNotification}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        ) : undefined
      }
    >
      <Text size={14}>
        {message}
      </Text>
    </Alert>
  );
};
